module.exports = __webpack_public_path__ + "img/thumbnail_Raccoon_j_erythristic.2ab56a7a.png";